/**
 * An enum that describes the sides of an Actor for collision
 */
export enum Side {
  None = 'None',
  Top = 'Top',
  Bottom = 'Bottom',
  Left = 'Left',
  Right = 'Right'
}
